import React from 'react';
import {injectIntl} from 'react-intl';
import messages from '../../../../res/translations/messages';
import {fillChartOptions} from '../../../utils/analytics';
import FullscreenChart from './FullscreenChart';
import {INSTANCE_FILTERS} from '../../../constants';

const X_INTERVAL = 1000 * 60 * 60 * 24; // 1 day

function* fillGaps(values) {
    for (let i = 0; i < values.length; i++) {
        yield values[i];
        if (values[i + 1]) {
            for (let counter = values[i][0] + X_INTERVAL; counter < values[i + 1][0]; counter += X_INTERVAL) {
                yield [counter, 0];
            }
        }
    }
}

const buildOptions = (config, data, hints, intl, instanceType) => {
    let title;
    switch (instanceType) {
        case INSTANCE_FILTERS.ALL:
            title = messages.chart.title.instanceCompletedAtAll;
            break;
        case INSTANCE_FILTERS.NOT_COMPLETED:
            title = messages.chart.title.instanceCompletedAtNotCompleted;
            break;
        case INSTANCE_FILTERS.COMPLETED:
        default:
            title = messages.chart.title.instanceCompletedAtCompleted;
            break;
    }
    config = Object.assign({title: intl.formatMessage(title)}, config);
    return fillChartOptions({
        chart: {type: 'areaspline'},
        legend: {enabled: false},
        xAxis: {minTickInterval: X_INTERVAL, type: 'datetime'},
        yAxis: {min: 0, minTickInterval: 1, title: {enabled: false}},
        series: [{data: [...fillGaps(data.values)]}],
    }, config, data, hints, intl);
};

const InstanceCompletedAtWidget = ({intl, data, params, hints, instanceType}) => (
    <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl, instanceType)} />
);

export default injectIntl(InstanceCompletedAtWidget);
